import { Dropdown } from "primereact/dropdown";
import { measurementUnits, systemCurrencies } from "./Utils";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";

export const currencyEditor = (options) => {
    return (
        <Dropdown
            value={options.value}
            options={systemCurrencies}
            onChange={(e) => options.editorCallback(e.value)}
            style={{ width: "100%" }}
        />
    );
};

export const priceEditor = (options, parameter, array, formik) => {
    return (
        <InputNumber
            inputStyle={{ width: '100%' }}
            value={options.value}
            onValueChange={(e) => {
                const updatedData = [...formik.values[array]];

                if (updatedData[options.rowIndex][parameter] !== e.value) {
                    updatedData[options.rowIndex][parameter] = e.value;
                    formik.setFieldValue(array, updatedData);
                }
            }}
            min={1}
            minFractionDigits={2}
            maxFractionDigits={2}
        />
    );
};

export const textEditor = (options) => {
    return (
        <InputText
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
        />
    );
};

export const numberEditor = (options, fractionDigits = 0) => {
    return (
        <InputNumber
            value={options.value}
            onValueChange={(e) => options.editorCallback(e.value)}
            minFractionDigits={fractionDigits}
            maxFractionDigits={fractionDigits}
        />
    );
};

export const numberEditorWithMeasurements = (options, parameter, formik, unitOfMeasurements) => {
  return (
    <InputNumber
      inputStyle={{ width: '100%' }}
      value={options.value}
      suffix={` ${unitOfMeasurements}`}
      onValueChange={(e) => {
        formik.setFieldValue(
          `order_products[${options.rowIndex}].${parameter}`,
          e.value
        );
      }}
      min={1}
      mode="decimal"
    />
  );
};

export const dropdownEditor = (options) => {
    return (
        <Dropdown
            value={options.value}
            options={measurementUnits}
            onChange={(e) => options.editorCallback(e.value)}
            style={{ width: "100%" }}
        />
    );
};